import * as React from "react";

function ReplyAllIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m60.72 208 154.1-133.8c10.03-8.656 11.12-23.81 2.469-33.84-8.688-10.06-23.81-11.2-33.85-2.486l-176 151.1C3.029 194.4 0 201 0 208c0 6.968 3.029 13.58 8.31 18.15l176 151.1C188.8 382.1 194.4 384 200 384c6.719 0 13.41-2.812 18.16-8.312 8.656-10.03 7.562-25.19-2.469-33.84L60.72 208zM424 184H216.5L343.7 74.2c10.03-8.656 11.12-23.81 2.469-33.84-8.688-10.06-23.85-11.2-33.85-2.486L136.3 189.9C131 194.4 128 201 128 208c0 6.968 3.029 13.58 8.31 18.15l176 151.1c4.531 3.937 10.13 5.846 15.69 5.846 6.719 0 13.41-2.812 18.16-8.312 8.656-10.03 7.562-25.19-2.469-33.84L216.5 232H424c57.34 0 104 46.65 104 103.1v119.1c0 15.1 10.8 25.8 24 25.8s24-10.7 24-24V336.9c0-84.7-68.2-152.9-152-152.9z"
  }));
}

const ForwardRef = React.forwardRef(ReplyAllIcon);
export default ForwardRef;